import { useEffect } from 'react';
import { useCurrentUser, usePrevious } from '@lib/hooks';
import { datadogRum } from '@datadog/browser-rum';

function useDatadogIdentify() {
  const user = useCurrentUser();
  const prevUserId = usePrevious(user?.id);

  useEffect(() => {
    if (user && user?.id !== prevUserId) {
      datadogRum.setUser({
        id: user.id,
        rootId: user.user,
        name: user.name,
        email: user.email,
        role: user.roles,
        type: user.type,
        segment: user.salesforceData.boardSegment,
        healthStatus: user.salesforceData.healthStatus,
        specialty: user.salesforceData.specialty,
        providers: user.salesforceData.providers,
        rolloutFlags: user.rollouts,
      });
    }
  }, [user, prevUserId]);
}

export default useDatadogIdentify;
